<template>
  <section v-if="dense">
    <v-card
      v-for="(filter, index) in template"
      :key="index"
      :flat="dense"
      v-show="getNumberOfProduct(filter.tags) > 0"
    >
      <v-card-title class="pb-0">
        <span class="subtitle-1" style="font-weight: bold;">{{
          filter.tags.join(", ")
        }}</span>
      </v-card-title>
      <v-card-text>
        <InventoryGrid
          :loading="loading"
          :filter="tags.length > 0 ? [...tags, ...filter.tags] : filter.tags"
          infinite
          :dense="dense"
          :searchProps="search"
          :showSearch="false"
          @update="v => $emit('update', v)"
        ></InventoryGrid>
      </v-card-text>
    </v-card>
  </section>
  <v-expansion-panels v-else>
    <v-row v-if="loading" align="center" justify="center" no-gutters>
      <v-progress-linear indeterminate color="primary"></v-progress-linear>
    </v-row>
    <draggable
      v-else-if="edit === true"
      v-model="templateModel"
      style="width: 100%;"
      handle=".panel-handle"
      group="category"
    >
      <v-expansion-panel
        class="my-2"
        v-for="(filter, index) in template"
        :key="index"
      >
        <v-expansion-panel-header class="py-1">
          <v-row align="center" justify="start" style="width: 90%;">
            <v-col cols="11" sm="1">
              <v-icon class="panel-handle" style="cursor: grab;"
                >fa-grip-lines</v-icon
              >
            </v-col>
            <v-col cols="11" sm="8" class="py-1">
              <InventoryTemplateTagsEditor
                v-if="edit === true"
                v-model="filter.tags"
              ></InventoryTemplateTagsEditor>
              <span v-else>
                <v-row align="center" no-gutters>
                  <v-chip v-for="tag in filter.tags" :key="tag" class="mr-1">
                    {{ tag }}
                  </v-chip>
                </v-row>
              </span>
            </v-col>
          </v-row>
        </v-expansion-panel-header>

        <v-expansion-panel-content eager>
          <InventoryGridTemplateEditor
            v-if="edit === true"
            :filter="filter.tags"
            ref="editor"
          ></InventoryGridTemplateEditor>
          <InventoryGrid
            v-else
            :loading="false"
            :filter="tags.length > 0 ? [...tags, ...filter.tags] : filter.tags"
            :records="records"
            :manual-records="manualRecords"
            :read-only="readOnly"
            :show-search="false"
            :searchProps="search"
            tag-order
            infinite
            hideHeader
            hideTop
            @update="v => $emit('update', v)"
          ></InventoryGrid>

          <v-row
            v-if="edit === true"
            align="center"
            justify="end"
            no-gutters
            class="mt-2"
            style="padding: 0 16px"
          >
            <v-btn x-small text @click="removeFromTemplate(filter, index)">
              Retirer la section
              <v-icon x-small right>fa-times</v-icon>
            </v-btn>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </draggable>
    <v-expansion-panel
      v-else
      class="my-2"
      v-for="(filter, index) in template"
      :key="index"
      v-show="getNumberOfProduct(filter.tags) > 0"
    >
      <v-expansion-panel-header class="py-1">
        <v-row align="center" dense justify="space-between">
          <v-col cols="10" sm="6" class="py-1">
            <InventoryTemplateTagsEditor
              v-if="edit === true"
              v-model="filter.tags"
            ></InventoryTemplateTagsEditor>
            <span v-else>
              <v-row align="center" no-gutters>
                <v-chip
                  :small="$vuetify.breakpoint.xsOnly"
                  v-for="tag in filter.tags"
                  :key="tag"
                  class="mr-1"
                >
                  {{ tag }}
                </v-chip>
              </v-row>
            </span>
          </v-col>
          <v-col cols="2">
            <v-row dense justify="end" align="center" no-gutters>
              <v-chip
                outlined
                small
                :disabled="getNumberOfProduct(filter.tags) === 0"
                >{{ getNumberOfProduct(filter.tags) }}
                <v-icon
                  x-small
                  class="ml-1"
                  color="rgba(0,0,0,0.43)"
                  v-show="$vuetify.breakpoint.smAndUp"
                  >fa-box</v-icon
                >
              </v-chip>
            </v-row>
          </v-col>
        </v-row>
      </v-expansion-panel-header>

      <v-expansion-panel-content :eager="edit === true">
        <InventoryGrid
          :loading="false"
          :filter="tags.length > 0 ? [...tags, ...filter.tags] : filter.tags"
          :records="records"
          :manual-records="manualRecords"
          :read-only="readOnly"
          :show-search="false"
          :searchProps="search"
          infinite
          hideHeader
          hideTop
          use-order
          @update="v => $emit('update', v)"
        ></InventoryGrid>
        <v-row
          v-if="edit === true"
          align="center"
          justify="end"
          no-gutters
          class="mt-2"
          style="padding: 0 16px"
        >
          <v-btn x-small text @click="removeFromTemplate(filter, index)">
            Retirer la section
            <v-icon x-small right>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-row v-if="!loading && edit === true" no-gutters class="my-3">
      <v-btn
        :block="$vuetify.breakpoint.xsOnly"
        @click="$emit('update:template', [...template, { tags: [] }])"
      >
        <v-icon left small>fa-plus</v-icon>Ajouter une section
      </v-btn>
    </v-row>
  </v-expansion-panels>
</template>

<script>
import draggable from "vuedraggable";
import InventoryGrid from "./InventoryGrid";
import InventoryTemplateTagsEditor from "./InventoryTemplateTagsEditor";
import InventoryGridTemplateEditor from "./InventoryGridTemplateEditor";
import { mapGetters } from "vuex";
export default {
  name: "InventoryRecordViewer",
  components: {
    draggable,
    InventoryGrid,
    InventoryTemplateTagsEditor,
    InventoryGridTemplateEditor
  },
  props: {
    template: {
      type: Array,
      required: true
    },
    records: {
      type: Array,
      required: false,
      default: () => []
    },
    tags: {
      type: Array,
      required: false,
      default: () => []
    },
    dense: {
      type: Boolean,
      default: false
    },
    manualRecords: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    edit: {
      type: Boolean,
      default: true
    },
    search: {
      default: undefined
    }
  },
  computed: {
    ...mapGetters(["getProducts"]),
    templateModel: {
      get() {
        return this.template;
      },
      set(v) {
        this.$emit("update:template", v);
      }
    }
  },
  methods: {
    async removeFromTemplate(filter, index) {
      const allow = await this.$dialog.confirm({
        text: "Voulez-vous vraiment retirer cette section du gabarit?",
        title: ""
      });
      if (allow) {
        this.template.splice(index, 1);
      }
    },
    async saveOrder() {
      const refs = this.$refs.editor;
      await Promise.all(refs.map(async x => await x.saveOrder()));
    },
    getNumberOfProduct(filter) {
      if (filter.length > 0) {
        if (this.tags.length > 0) {
          let items = this.getProducts.filter(
            x =>
              x.is_deleted === false &&
              x.data !== null &&
              filter.every(t => x.data.tags.includes(t)) &&
              this.tags.every(t => x.data.tags.includes(t))
          );
          if (this.search !== undefined) {
            items = items.filter(
              x => this.customFilter(null, this.search, x) === true
            );
          }
          return items.length;
        } else {
          let items = this.getProducts.filter(
            x =>
              x.is_deleted === false &&
              x.data !== null &&
              filter.every(t => x.data.tags.includes(t))
          );
          if (this.search !== undefined) {
            items = items.filter(
              x => this.customFilter(null, this.search, x) === true
            );
          }
          return items.length;
        }
      } else {
        return 0;
      }
    },
    customFilter(value, search, item) {
      if (search !== null) {
        const normalizeSearch = search
          .toLowerCase()
          .replace(/\s/g, "")
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");
        const itemName = item.nom
          .toLowerCase()
          .replace(/\s/g, "")
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");

        if (itemName.indexOf(normalizeSearch) !== -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }
  }
};
</script>

<style></style>
